module.exports = __webpack_public_path__ + "img/profile-bg6.86cbd2d6.jpg";